import { siteConfig } from '@/mocks/siteConfig';

export default function Reputation() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            用户口碑
          </h2>
          <p className="text-sm text-secondary-500">听听用户们怎么说</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {siteConfig.reputation.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className={`text-sm ${i < item.rating ? 'text-accent-500 ri-star-fill' : 'text-secondary-300 ri-star-line'}`}></i>
                  </div>
                ))}
              </div>
              <p className="text-sm text-secondary-700 leading-relaxed mb-4">
                &ldquo;{item.content}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center text-accent-700 text-sm font-medium">
                  {item.name.charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                  <p className="text-xs text-secondary-500">{item.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}